package com.essntl.features.service.ui.addeditservice.components

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.service.ui.addeditservice.AddEditServiceState
import com.essntl.features.service.ui.addeditservice.AddEditServiceValidation
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.utils.spacing
import com.mohamedrejeb.richeditor.model.RichTextState

@Composable
internal fun SubmitButton(
    richTextState: RichTextState,
    state: AddEditServiceState,
    submitText: String,
    onEnableEdit: () -> Unit,
    onSubmit: (description: String) -> Unit,
    enabled: Boolean,
    validation: AddEditServiceValidation,
    modifier: Modifier = Modifier,
) {
    val currentUserRole = remember(state.getProfile.data) {
        state.getProfile.data?.role
    }

    val isEdit = remember(state.service.value.id) {
        state.service.value.id.isNotBlank()
    }

    EsLargePrimaryButton(
        onClick = {
            val htmlString =
                if (richTextState.annotatedString.text.isEmpty())
                    ""
                else
                    richTextState.toHtml()

            if (!enabled)
                onEnableEdit()
            else if (validation.addEditServiceForm.validate())
                onSubmit(htmlString)
        },
        text = submitText,
        loading = state.addEditService.isLoading,
        enabled = if (!enabled) {
            (currentUserRole == ProfileModel.Role.Admin ||
                currentUserRole == ProfileModel.Role.Supervisor ||
                currentUserRole == ProfileModel.Role.Owner)
        } else if (isEdit) {
            state.isEditMode && validation.addEditServiceForm.isValid
        } else {
            validation.addEditServiceForm.isValid
        },
        modifier = modifier
            .padding(horizontal = 2.5.spacing)
            .width(174.dp),
    )
}
